export const fireChangeEvent = (element, displayValue) => {
  const event = new CustomEvent('accordion:displayValueChange', {
    bubbles: true,
    detail: { displayValue },
  });
  element.dispatchEvent(event);
};
